document.addEventListener( 'click', function ( event ) {
	const link = event.target.closest( '.faculties-pagination a' );

	if ( ! link ) {
		return;
	}

	event.preventDefault();

	const wrapper = document.querySelector( '.faculties-wrapper' );
	if ( ! wrapper ) {
		window.location.href = link.href;
		return;
	}

	const loader = wrapper.querySelector( '.faculties-loader' );
	if ( loader ) {
		loader.classList.add( 'is-active' );
	}

	fetch( link.href, {
		credentials: 'same-origin',
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
		},
	} )
		.then( function ( response ) {
			return response.text();
		} )
		.then( function ( html ) {
			const temp = document.createElement( 'div' );
			temp.innerHTML = html;

			const newWrapper = temp.querySelector( '.faculties-wrapper' );

			if ( ! newWrapper ) {
				window.location.href = link.href;
				return;
			}

			wrapper.replaceWith( newWrapper );

			const target = document.getElementById( 'faculties' );
			if ( target ) {
				const headerOffset = 120;
				const elementPosition = target.getBoundingClientRect().top;
				const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

				window.scrollTo( {
					top: offsetPosition,
					behavior: 'smooth',
				} );
			}
		} )
		.catch( function () {
			window.location.href = link.href;
		} );
} );
